document.addEventListener('DOMContentLoaded',()=>{
    const productCards = document.querySelectorAll('.byob-product-col');
    const countEl = document.getElementById('byob-selected-count');
    const addBtn = document.getElementById('byob-add-to-cart');
    const comparePriceEl = document.getElementById('byob-compare-price');
    const finalPriceEl = document.getElementById('byob-final-price');
    const selectedImageBoxes = document.querySelectorAll('.byob-selected-image');
    const bundleTabs = document.querySelectorAll('.byob-bundle-tab');
    const imageContainer = document.querySelector('.byob-selection-image');
    let selectedVariants=[];
    const activeTab = document.querySelector('.byob-bundle-tab.active');
    let currentBundleCount = Number(activeTab.dataset.count);
    let currentBundlePrice = Number(activeTab.dataset.price);

    function formatPrice(price){
        return '₹' + Number(price).toLocaleString('en-IN');
    }

    function resetSelections(){
        selectedVariants=[];
        productCards.forEach(card => {
            card.classList.remove('is-selected');
            const btn = card.querySelector('.add-to-cart-byob');
            if(btn){
                btn.innerText = 'Add to Cart';
            }
        });
        updateUI();
    }

    function updateSelectedImages(){
        selectedImageBoxes.forEach((box,index)=>{
            box.innerHTML = '';
            if(index < currentBundleCount){
                box.style.display = 'flex';
            }else{
                box.style.display = 'none';
            }

        });

        selectedVariants.forEach(( product, index) =>{
            if(selectedImageBoxes[index]){
                selectedImageBoxes[index].innerHTML=
                `
                    <div class="byob-selected-item">
                        <img src="${product.image}" alt="">
                        <button class="byob-remove-product" data-id="${product.id}">-</button>
                    </div>
                `;
            }
        });

        if(currentBundleCount >= 6){
            imageContainer.classList.add('compact');
        } else{
            imageContainer.classList.remove('compact');
        }
    }

        function updatePrices(){
        let totalComparePrice = 0;
        selectedVariants.forEach(product=>{
            totalComparePrice += Number(product.comparePrice || 0);
        });

        const comparePrice = totalComparePrice/100;
        const isComplete = selectedVariants.length === currentBundleCount;
        const saved = Math.max(0, Math.round(comparePrice - currentBundlePrice));
        const saveEl = document.getElementById('byob-save-badge');

        if(!isComplete){
            comparePriceEl.innerHTML = '';
            finalPriceEl.innerHTML = '';
            if(saveEl){ saveEl.innerHTML = ''; }
            return;
        }

        if(saveEl){
            saveEl.innerHTML = saved > 0 ? `<span class="byob-saved">Save: ${formatPrice(saved)}</span>` : '';
        }
        finalPriceEl.innerHTML = `<span>${formatPrice(currentBundlePrice)}</span>`;
        comparePriceEl.innerHTML = `<span style="text-decoration:line-through;">${formatPrice(comparePrice)}</span>`;
    }

    function updateUI(){
        countEl.textContent = selectedVariants.length;
        addBtn.disabled = selectedVariants.length !== currentBundleCount;

        const bar = document.querySelector('.byob-bottom-bar');
        if(bar){
            bar.classList.toggle('has-selection', selectedVariants.length > 0);
            bar.classList.toggle('is-complete', selectedVariants.length === currentBundleCount);
        }

        const remaining = currentBundleCount - selectedVariants.length;
        document.querySelector('.byob-selection-status').innerHTML = remaining > 0
            ? `Pick <span id="byob-selected-count">${remaining}</span> more for ₹${Number(currentBundlePrice).toLocaleString('en-IN')}`
            : `<span id="byob-selected-count">${selectedVariants.length}</span>/${currentBundleCount} selected`;

        updateSelectedImages();

        document.querySelectorAll('.byob-remove-product').forEach(btn =>{
            btn.addEventListener('click',(e)=>{
                e.stopPropagation();
                const variantId = btn.dataset.id;
                selectedVariants = selectedVariants.filter(
                    item => item.id !== variantId
                );

                document.querySelectorAll('.byob-product-col').forEach(card=>{
                    if(card.dataset.variantId === variantId){
                        card.classList.remove('is-selected');
                        const button = card.querySelector('.add-to-cart-byob');
                        if(button){
                            button.innerText = 'Add to Cart';
                        }
                    }
                });
                updateUI();
            });
        });
        updatePrices();
    }

    bundleTabs.forEach( tab => {
        tab.addEventListener('click',()=>{
            bundleTabs.forEach( btn => {
                btn.classList.remove('active');
            });
            tab.classList.add('active');
            currentBundleCount = Number(tab.dataset.count);
            currentBundlePrice = Number(tab.dataset.price);

            resetSelections();
        });
    });

    productCards.forEach(card=>{
        card.addEventListener('click', ()=> {
            const variantId = card.dataset.variantId;
            const image = card.dataset.image;
            const price = Number(card.dataset.price);
            const comparePrice = Number(card.dataset.comparePrice);

            if(!variantId){
                alert('Variant ID Missing');
                return;
            }
            const btn = card.querySelector('.add-to-cart-byob');

            if( card.classList.contains('is-selected')){
                card.classList.remove('is-selected');
                btn.innerText='Add to Cart';
                selectedVariants=selectedVariants.filter( item => item.id !== variantId);
            }else{
                if(selectedVariants.length >= currentBundleCount){
                    alert(`You can select only ${currentBundleCount} products`);
                    return;
                }

                card.classList.add('is-selected');
                btn.innerText = 'Remove From Cart';
                selectedVariants.push({
                    id:variantId,
                    image,
                    price,
                    comparePrice
                });

                if(selectedVariants.length === currentBundleCount){
                    confetti({
                        particleCount: 150,
                        angle: 60,
                        spread: 80,
                        origin: {x: 0, y: 0.7}
                    });

                    confetti({
                        particleCount: 150,
                        angle: 120,
                        spread: 80,
                        origin: {x: 1, y: 0.7}
                    });
                }
            }
            updateUI();
        });
    });

    async function refreshCartUI(){
        try{
            const response = await fetch('/cart.js');
            const cart = await response.json();

            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh',{
                    bubbles:true
                })
            );

            const cartDrawer = document.querySelector('cart-drawer');
            if(cartDrawer && typeof cartDrawer.renderContents === 'function'){
                cartDrawer.renderContents(cart);
            }
        } catch(e){
            console.log('Cart Refresh Failed',e);
        }

    }

    addBtn.addEventListener('click', async ()=> {
        if(selectedVariants.length !== currentBundleCount){
            alert(`Please select ${currentBundleCount} products`);
            return;
        }

        try{
            addBtn.disabled=true;
            addBtn.innerHTML = 'Preparing...';

            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();

            if(cartData.items && cartData.items.length >0){
                await fetch('/cart/clear.js',{
                    method:'POST',
                    headers:{
                        'Content-Type':'application/json',
                        'Accept':'application/json'
                    }
                });

                await new Promise(resolve=>setTimeout(resolve,1000));
            }

            addBtn.innerHTML = 'Adding Products...';

            const items=selectedVariants.map( item=> ({
                id:Number(item.id),
                quantity:1
            }));

            const response = await fetch('/cart/add.js',{
                method:'POST',
                headers:{
                    'Content-Type':'application/json',
                    'Accept':'application/json'
                },
                body:JSON.stringify({items})
            });

            if(!response.ok){
                throw new Error('Add To Cart Failed');
            }

            addBtn.innerHTML = 'Going to checkout...';
            window.location.href = '/checkout';

        } catch(error) {
            console.error(error);
            alert('Something went wrong');
            addBtn.disabled = false;
            addBtn.innerHTML = 'Go to Checkout';
        }
    });
    updateUI();
});